import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEnGb from '@angular/common/locales/en-GB';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import { LocaleConfig } from '@locale/models/locale-config';
import { TUI_ENGLISH_LANGUAGE, TUI_FRENCH_LANGUAGE, TUI_GERMAN_LANGUAGE, TUI_SPANISH_LANGUAGE } from '@taiga-ui/i18n';
import { de, enGB, enUS, es, fr } from 'date-fns/locale';

export const availableLocales: LocaleConfig[] = [
  {
    code: 'fr',
    flag: 'fr',
    label: 'Français',
    angularConfig: {
      locale: localeFr,
    },
    dateFnsConfig: {
      format: 'dd/MM/yyyy',
      locale: fr,
    },
    tuiConfig: {
      countryIsoCode: 'FR',
      format: { mode: 'DMY', separator: '/' },
      language: TUI_FRENCH_LANGUAGE,
      languageName: 'french',
    },
  },
  {
    code: 'en-US',
    flag: 'us',
    label: 'English (US)',
    angularConfig: {
      locale: localeEn,
    },
    dateFnsConfig: {
      format: 'MM/dd/yyyy',
      locale: enUS,
    },
    tuiConfig: {
      countryIsoCode: 'US',
      format: { mode: 'MDY', separator: '/' },
      language: TUI_ENGLISH_LANGUAGE,
      languageName: 'english',
    },
  },
  {
    code: 'en-GB',
    flag: 'gb',
    label: 'English (UK)',
    angularConfig: {
      locale: localeEnGb,
    },
    dateFnsConfig: {
      format: 'dd/MM/yyyy',
      locale: enGB,
    },
    tuiConfig: {
      countryIsoCode: 'GB',
      format: { mode: 'DMY', separator: '/' },
      language: TUI_ENGLISH_LANGUAGE,
      languageName: 'english',
    },
  },
  {
    code: 'es',
    flag: 'es',
    label: 'Español',
    angularConfig: {
      locale: localeEs,
    },
    dateFnsConfig: {
      format: 'dd/MM/yyyy',
      locale: es,
    },
    tuiConfig: {
      countryIsoCode: 'ES',
      format: { mode: 'DMY', separator: '/' },
      language: TUI_SPANISH_LANGUAGE,
      languageName: 'spanish',
    },
  },
  {
    code: 'de',
    flag: 'de',
    label: 'Deutsch',
    angularConfig: {
      locale: localeDe,
    },
    dateFnsConfig: {
      format: 'dd.MM.yyyy',
      locale: de,
    },
    tuiConfig: {
      countryIsoCode: 'DE',
      format: { mode: 'DMY', separator: '.' },
      language: TUI_GERMAN_LANGUAGE,
      languageName: 'german',
    },
  },
];
